import './App.css';
import CardList from './components/cardList';
import Header from './components/header';
import List from './components/list';

import { CardContextProvider } from './context/CardContext';
import { useUserStore } from './stores/userStore';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faBroom, faSort, faPenToSquare, faTrashCan, faEye, faEyeSlash, faCheck, faArrowLeft, faImage, faLink, faHeading, faParagraph, faPlus, faSun, faCloudSun, faCloud, faSmog, faCloudSunRain, faCloudRain, faCloudShowersHeavy, faSnowflake, faIcicles, faCloudBolt, faCloudMeatball, faLocationArrow, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons'

library.add(
  faSort, faBroom, faPenToSquare, faTrashCan, 
  faEye, faEyeSlash, faPenToSquare, faCheck, faArrowLeft, faImage, 
  faLink, faHeading, faParagraph, faPlus,
  faSun, faCloudSun, faCloud, faSmog, faCloudSunRain, faCloudRain, faCloudShowersHeavy, faSnowflake,
  faIcicles, faCloudBolt, faCloudMeatball, faLocationArrow, faChevronUp, faChevronDown)

function App() {
  const displayCards = useUserStore(state => state.displayCards)
  const displayNote = useUserStore(state => state.displayNote)
  const displayTodos = useUserStore(state => state.displayTodos)
  const displayWeather = useUserStore(state => state.displayWeather)

  return (
    <div className={`App ${ !displayCards && !displayNote && !displayWeather ? 'focus-mode' : '' } ${ !displayCards && !displayNote && displayWeather ? 'narrow-weather' : '' }`}>
      <Header />
      <main className={`${ !displayCards && !displayNote && !displayWeather ? 'no-cards' : '' }`}>
        <div className="inner">
          { displayTodos ? <List /> : ''}
          <div className={`card-grid ${ !displayCards && !displayNote && !displayWeather ? 'empty ' : '' }`}>
            <CardContextProvider>
              { displayCards || displayNote || displayWeather ? <CardList /> : '' }
            </CardContextProvider>
          </div>
        </div>
      </main>
      <footer>
        <div className="inner">
          <p>Made by <a href="https://joshwayman.com">Josh Wayman</a>.</p> 
          {displayWeather ? <p className="weather-attribution">Weather data by <a href="https://open-meteo.com/">Open-Meteo.com</a></p> : ''}
        </div>
      </footer>
    </div>
  );
}

export default App;
